// promo-banner-track.js — GA4 engagement events for promo banners (sections/promo-banner-fall26.liquid).
//
// Markup contract:
//   [data-promo-track="<promo id>"]        the banner root
//   [data-promo-click="<target>"]          a link inside it (e.g. "cta", "image")
//
// Events (both carry promo_id; register promo_id + click_target as custom dimensions in GA4 Admin
// to see them in reports — the event COUNTS work without that):
//   promo_banner_view    ≥50% of the banner on screen, once per page view   → the denominator
//   promo_banner_click   a [data-promo-click] link is clicked, + click_target → the numerator
//
// THE TIMING TRAP (same as assets/ab-tracking.js): gtag() exists long before the Google & YouTube
// app's GA4 config has loaded, and an event sent in that gap is SILENTLY DROPPED. So the view event
// waits for google_tag_manager["G-…"] (the container really initialised), polling briefly.
// Clicks can't wait — the page is navigating — but by the time someone clicks, GA4 is ready in
// practice, and transport_type 'beacon' lets the hit survive the navigation.

(function () {
  'use strict';

  // No tracking in the theme editor.
  if (window.Shopify && window.Shopify.designMode) return;

  function ga4Ready() {
    if (typeof window.gtag !== 'function') return false;
    var gtm = window.google_tag_manager;
    if (!gtm) return false;
    for (var key in gtm) {
      if (key.indexOf('G-') === 0) return true;
    }
    return false;
  }

  function send(name, params) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', name, params);
  }

  // Send once GA4 is configured; ~10s ceiling, then send anyway (a maybe-dropped hit beats a
  // certainly-missing one).
  function sendWhenReady(name, params) {
    var tries = 0;
    (function attempt() {
      if (ga4Ready() || tries++ >= 50) { send(name, params); return; }
      setTimeout(attempt, 200);
    })();
  }

  function setup(root) {
    var promoId = root.getAttribute('data-promo-track');
    if (!promoId || root.hasAttribute('data-promo-tracked')) return;
    root.setAttribute('data-promo-tracked', '');

    // View — once per page view, when at least half of the banner is visible.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.disconnect();
          sendWhenReady('promo_banner_view', { promo_id: promoId });
        });
      }, { threshold: 0.5 });
      io.observe(root);
    }

    // Click — delegated, so it covers every [data-promo-click] link in the banner.
    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-promo-click]');
      if (!link || !root.contains(link)) return;
      send('promo_banner_click', {
        promo_id: promoId,
        click_target: link.getAttribute('data-promo-click'),
        link_url: link.href,
        transport_type: 'beacon'
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-promo-track]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
